// Countries and cemetery suggestions for the BurialPreferenceInput.
// Suggestions only — users can still type any free-text value.

import { CemeteryOption, MALAYSIAN_CEMETERIES } from './malaysian-cemeteries'

export type BurialCountryCode = 'MY' | 'SG'

export interface BurialCountryOption {
  code: BurialCountryCode
  label: string
}

export const BURIAL_COUNTRIES: BurialCountryOption[] = [
  { code: 'MY', label: 'Malaysia' },
  { code: 'SG', label: 'Singapore' },
]

export const BURIAL_LOCATIONS: Record<BurialCountryCode, CemeteryOption[]> = {
  MY: MALAYSIAN_CEMETERIES,
  // Singapore's Muslim burial sites; the active cemetery is Choa Chu Kang.
  SG: [
    { label: 'Choa Chu Kang Muslim Cemetery, Singapore', value: 'Choa Chu Kang Muslim Cemetery, Singapore' },
    { label: 'Pusara Aman Muslim Cemetery, Jalan Bahar, Singapore', value: 'Pusara Aman Muslim Cemetery, Jalan Bahar, Singapore' },
  ],
}
